import { React } from 'react';

const DocListSkeleton = () => {
  const placeholders = Array.from({ length: 10 });

  return (
    <div className='doclist-skeleton'>
      {placeholders.map((_, idx) => (
        <div className='doc-skeleton-card card' key={idx}>
          <div className='card-body'>
            <div className='skeleton-main'>
              <div className='skeleton-thumbnail skeleton-line skeleton-pill shimmer' />
              <div className='skeleton-content'>
                <div className='skeleton-line skeleton-title shimmer' />
                <div className='skeleton-line shimmer' />
                <div className='skeleton-line shimmer' />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DocListSkeleton;
